// src/components/MaintenanceLists/BikeHeader.js
import React from 'react';
import FormattedDate from '../FormattedDate';
import { Button } from 'react-bootstrap';

/**
 * Header component for displaying bike details and action buttons
 * 
 * @param {Object} props - Component props
 * @param {Object} props.bike - Bike data object
 * @param {boolean} props.isOwner - Whether the current user is the bike owner
 * @param {Function} props.onEditClick - Function to handle edit button click
 * @returns {JSX.Element} Rendered component
 */
const BikeHeader = ({ bike, isOwner, onEditClick }) => {
  return (
    <div className="listing-header-section">
      <div className={`listing-title-container ${isOwner ? 'editable' : ''}`}>
        <h2>{bike.nickname || `${bike.year} ${bike.make} ${bike.model}`}</h2>
        
        <div className="listing-meta">
          <div className="data">
            {bike.year} {bike.make} {bike.model}
          </div>
          
          {bike.purchaseDate && (
            <div className="">
              <span>Purchased: </span>
              <FormattedDate date={bike.purchaseDate} />
              {bike.purchasePrice && (
                <span className="listing-price"> for £{parseFloat(bike.purchasePrice).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              )}
              {bike.initialMileage && (
                <span className="mileage-display"> at {bike.initialMileage.toLocaleString()} miles</span>
              )}
            </div>
          )}
          
          <div className="listing-timestamp">
            <span>Last updated: </span>
            <FormattedDate date={bike.lastEdited} />
          </div>
        </div>
      </div>
      
      
    {isOwner && (
        <Button
            variant="secondary"
            onClick={onEditClick}
        >
            Edit Details
        </Button>
    )}
      
    </div>
  );
};

export default BikeHeader;